export default {
    methods: {
        setData(collection, keys = null, collectionKey = false) {
            if(!collection) {
                return
            }
            if(typeof keys === 'object') {
                keys.forEach((key) => {
                    if (collectionKey) {
                        if (collection[collectionKey] && collection[collectionKey][key]) {
                            this.report[key] = collection[collectionKey][key]
                        }
                    } else {
                        if (collection[key]) {
                            this.report[key] = collection[key]
                        }
                    }
                })
            } else {
                if (collectionKey) {
                    if (collection[collectionKey]) {
                        this.report[keys] = collection[collectionKey]
                    }
                } else {
                    if (collection[keys]) {
                        this.report[keys] = collection[keys]
                    }
                }
            }
        }
    }
}